import { rei } from "@/services/api"

class TarefasService {
  static cumprirTarefaManual (tarefa_id) {
    return rei.post(`cumprir-tarefa`, {tarefa_id: tarefa_id}).then(res => res.data)
  }
}

export default TarefasService
